import { NgModule } from '@angular/core';
import { SimpleTextPanelComponent } from '@fi-shared/fi-text-panel/simple-text-panel/simple-text-panel.component';
import { AdvancedTextPanelFontStyleService } from '@fi-shared/fi-text-panel/text-panel-services/advanced-text-panel-font-style.service';
import { AdvancedTextPanelListsService } from '@fi-shared/fi-text-panel/text-panel-services/advanced-text-panel-lists.service';
import { AdvancedTextPanelJustifyService } from '@fi-shared/fi-text-panel/text-panel-services/advanced-text-panel-justify.service';
import { AdvancedTextPanelBufferService } from '@fi-shared/fi-text-panel/text-panel-services/advanced-text-panel-buffer.service';
import { AdvancedTextPanelHistoryService } from '@fi-shared/fi-text-panel/text-panel-services/advanced-text-panel-history.service';
import { AdvancedTextPanelMediaLinkService } from '@fi-shared/fi-text-panel/text-panel-services/advanced-text-panel-media-link.service';
import { AdvancedTextPanelRemoveFormatService } from '@fi-shared/fi-text-panel/text-panel-services/advanced-text-panel-remove-format.service';
import { AdvancedTextPanelPasteDialogComponent } from '@fi-shared/fi-text-panel/advanced-text-panel/advanced-text-panel-paste-dialog/advanced-text-panel-paste-dialog.component';
import { FiAdvancedTextPanelTableHelperService } from '@fi-shared/fi-text-panel/text-panel-services/advanced-text-panel-table-helper.service';
import { AdvancedTextPanelComponent } from '@fi-shared/fi-text-panel/advanced-text-panel/advanced-text-panel.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ColorPickerComponent, ColorPickerDirective } from 'ngx-color-picker';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiContenteditableModelModule } from '@fi-shared/contenteditable-model/contenteditable-model.module';
import { FiAiAssistanceModule } from '@fi-shared/fi-ai-assistance/fi-ai-assistance.module';
import { FiTextPanelHelperService } from '@fi-shared/fi-text-panel/text-panel-services/fi-text-panel-helper.service';
import { FiGiphyModule } from '@fi-shared/fi-giphy/fi-giphy.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ColorPickerComponent,
        ColorPickerDirective,
        MatMenuModule,
        MatIconModule,
        FiAppTextSharedModule,
        FiContenteditableModelModule,
        FiAiAssistanceModule,
        ColorPickerDirective,
        FiGiphyModule,
    ],
    declarations: [SimpleTextPanelComponent, AdvancedTextPanelComponent, AdvancedTextPanelPasteDialogComponent],
    providers: [
        AdvancedTextPanelFontStyleService,
        AdvancedTextPanelListsService,
        AdvancedTextPanelJustifyService,
        AdvancedTextPanelBufferService,
        AdvancedTextPanelHistoryService,
        AdvancedTextPanelMediaLinkService,
        AdvancedTextPanelRemoveFormatService,
        AdvancedTextPanelPasteDialogComponent,
        FiAdvancedTextPanelTableHelperService,
        FiTextPanelHelperService,
    ],
    exports: [SimpleTextPanelComponent, AdvancedTextPanelComponent],
})
export class FiTextPanelModule {}
